export const clamp = (num: number, min: number, max: number) =>
  Math.min(Math.max(num, min), max)

export const formatNumber = (number: number | string) => {
  return +number > 10_000
    ? number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'")
    : number
}
export const parseJwt = (token?: string): {sub: string} | null => {
  if (!token) return null
  var base64Url = token?.split('.')[1]
  var base64 = base64Url?.replace(/-/g, '+').replace(/_/g, '/')
  var jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join('')
  )

  return JSON.parse(jsonPayload)
}
